/**
 * Funcion que no tiene parametros ni retorna ningun valor
 */
export function funcionVacia() { }
/**
 * Esta funcion crea un objeto vacio
 * @returns Objeto vacio sin atributos
 */
export function objetoVacio() {
    return {}
}
/**
 * Esta funcion te retorna el mismo @elemento dado como parametro
 * @param {*} elemento - Elemento que sera devuelto por la funcion
 * @returns Elemento sin modificaciones que le pasaron como parametroo
 */
export function retornoMismoValor(elemento) {
    return elemento;
}